import PropTypes from 'prop-types';
import React from 'react';
import { List } from 'immutable';
import _ from 'lodash';
import classnames from 'classnames';

import { translate as t } from '../../lib/I18n';
import RailcardsStore from '../../stores/RailcardsStore';
import RailcardsActions from '../../actions/RailcardsActions';
import connectToStores from '../../helpers/connectToStores';

import Icon from '../general/Icon';
import PureRenderComponent from '../PureRenderComponent';
import Select from '../form/Select';

function _getStateFromStores ({ smartcard, filterOutRailcards }) {
    return {
        railcardTypes: filterOutRailcards ? RailcardsStore.getSome({ smartcard, filterOutRailcards }) : RailcardsStore.getAll({ smartcard })
    };
}

@connectToStores([ RailcardsStore ], _getStateFromStores)
class Railcard extends PureRenderComponent {

    static propTypes = {
        smartcard: PropTypes.bool,
        value: PropTypes.string,
        railcardTypes: PropTypes.instanceOf(List),
        onChange: _.noop,
        error: PropTypes.string,
        required: PropTypes.bool,
        placeholder: PropTypes.string,
        filterOutRailcards: PropTypes.arrayOf(PropTypes.string),
        className: PropTypes.string
    };

    static defaultProps = {
        smartcard: false,
        value: '',
        railcardTypes: null,
        onChange: _.noop,
        error: '',
        required: false,
        placeholder: t('booking.railcards.select'),
        filterOutRailcards: [],
        className: ''
    };

    UNSAFE_componentWillMount () {
        const { smartcard, railcardTypes } = this.props;
        if (!railcardTypes) {
            _.defer(RailcardsActions.load, { smartcard });
        }
    }

    _handleChange = (event) => {
        const { value } = event.target;
        const railcard = RailcardsStore.get(value);
        this.props.onChange(railcard);
    };

    render () {
        const { railcardTypes, error, required, placeholder, className } = this.props;

        const inputProps = {
            type: 'select',
            id: 'railcards__types',
            value: this.props.value,
            className: classnames('railcards__types', { 'input--invalid': error }),
            onChange: this._handleChange,
            disabled: !railcardTypes,
        };

        return (
            <span className={ classnames(`select-container ${className}`, { 'input--required': required }) }>
                <Icon icon="dropdown" />

                { required && <Icon icon="mandatory" /> }

                <label className="sr-only" htmlFor="railcards__types">
                    { `${error}. ` }{ t('booking.railcards.select') }
                </label>

                <Select { ...inputProps }>
                    <option value="">
                        { placeholder }
                    </option>

                    { railcardTypes && railcardTypes.map((type, key) => {
                        const props = { value: type.code, key };
                        return (
                            <option { ...props }>
                                { type.name }
                            </option>
                        );
                    }) }
                </Select>
            </span>
        );
    }
}


export default Railcard;




// WEBPACK FOOTER //
// ./src/components/search/RailcardTypes.js